<template>
  <div>
    <form class="form-box">
      <b-container class="container-box">
        <b-row class="no-gutters">
          <b-col>
            <h1 class="font-weight-bold header-main text-uppercase">
              {{ $t("importprodata") }}
            </h1>
          </b-col>
        </b-row>

        <b-row class="no-gutters bg-white p-3 mt-3">
          <b-col class="">
            <UploadFile
              :textFloat="$t('importfile')"
              :placeholder="$t('pleaseUpload')"
              format="excel"
              name="file"
              :text="$t('excelOnly')"
              v-model="form.file"
              :fileName="filename"
              isRequired
              v-on:onFileChange="onExcelChange"
              v-on:delete="deleteFile"
              :v="$v.form.file"
            />

            <b-row class="mt-5">
              <b-col md="6">
                <b-button href="/product" class="btn-details-set">{{
                  $t("cancel")
                }}</b-button>
              </b-col>
              <b-col md="6" class="text-sm-right">
                <b-button
                  class="btn btn-success btn-details-set ml-md-2 text-uppercase"
                  :disabled="isDisable"
                  @click="importData"
                  >{{ $t("import") }}</b-button
                >
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-container>
    </form>

    <ModalAlert ref="modalAlert" :text="modalMessage" />
    <ModalAlertError ref="modalAlertError" :text="modalMessage" />
    <ModalLoading ref="modalLoading" :hasClose="false" />
  </div>
</template>

<script>
import UploadFile from "@/components/inputs/UploadFile";
import { required } from "vuelidate/lib/validators";
import ModalAlert from "@/components/modal/alert/ModalAlert";
import ModalAlertError from "@/components/modal/alert/ModalAlertError";
import ModalLoading from "@/components/modal/alert/ModalLoading";

export default {
  name: "ProductImportData",
  components: {
    UploadFile,
    ModalAlert,
    ModalAlertError,
    ModalLoading,
  },
  data() {
    return {
      isDisable: true,
      hasEmailorOnSubmit: false,
      importerror: false,
      error: true,
      filename: "",
      form: {
        file: "",
      },
      modalMessage: ""
    };
  },
  validations: {
    form: {
      file: { required },
    },
  },
  created: async function () {
    this.$isLoading = true;
  },
  methods: {
    onExcelChange(file) {
      this.filename = file.name;
      this.isDisable = false;

      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.form.file = reader.result;
      };
    },
    deleteFile(value) {
      this.form.file = null;
      this.filename = null;
    },
    importData: async function (id) {
      this.$v.form.$touch();

      if (this.$v.form.$error) {
        return;
      }

      this.submit();
    },
    submit: async function (id) {
      this.isDisable = true;
      this.$refs.modalLoading.show();

      let data = await this.$callApi(
        "post",
        `${this.$baseUrl}/api/product/ImportProduct`,
        null,
        this.$headers,
        this.form
      );
      this.modalMessage = data.message;
      this.$refs.modalLoading.hide();
      this.isDisable = false;
      if (data.result == 1) {
        this.$refs.modalAlert.show();
        this.form.file = null;
        this.filename = null;
        this.$v.form.$reset();
        setTimeout(() => {
          this.$refs.modalAlert.hide();
        }, 3000);
      }
    },
  },
};
</script>